import { AccountSecurityFormType } from './AccountSecurity';

export enum AccountSecurityActionType {
    CLOSE_ACCOUNT_SECURITY_OVERLAY = 'CLOSE_ACCOUNT_SECURITY_OVERLAY',
    OPEN_ACCOUNT_SECURITY_OVERLAY = 'OPEN_ACCOUNT_SECURITY_OVERLAY',
    CHANGE_ACCOUNT_SECURITY_OVERLAY = 'CHANGE_ACCOUNT_SECURITY_OVERLAY',
    CLEAR_PASSWORD = 'CLEAR_PASSWORD',
}

export type AccountSecurityAction =
    | { type: AccountSecurityActionType.CLOSE_ACCOUNT_SECURITY_OVERLAY; payload: {} }
    | { type: AccountSecurityActionType.OPEN_ACCOUNT_SECURITY_OVERLAY; payload: {} }
    | {
          type: AccountSecurityActionType.CHANGE_ACCOUNT_SECURITY_OVERLAY;
          payload: AccountSecurityFormType;
      }
    | { type: AccountSecurityActionType.CLEAR_PASSWORD; payload: {} };
